import React, { useState, useEffect } from 'react';
import supabase from '../../supabase/supabase';
import { FiMail, FiSave, FiSend, FiCode, FiEye, FiCopy, FiCheck } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const AUTH_TEMPLATES = [
  {
    name: 'Confirm Signup / Verify Account',
    subject: 'Welcome to Ceylanthro! Confirm your email',
    html: `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>
<body style="margin: 0; padding: 0; background-color: #f4f5f3; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; -webkit-font-smoothing: antialiased;">
  <table width="100%" border="0" cellspacing="0" cellpadding="0" style="background-color: #f4f5f3; padding: 40px 0;">
    <tr>
      <td align="center">
        <table width="600" border="0" cellspacing="0" cellpadding="0" style="background-color: #ffffff; border-radius: 16px; overflow: hidden; box-shadow: 0 10px 30px rgba(0,0,0,0.08); margin: 0 auto;">
          <tr>
            <td align="center" style="background-color: #2c3625; padding: 45px 20px; text-align: center; border-bottom: 4px solid #d4af37;">
              <img src="https://res.cloudinary.com/dfg8nrgvf/image/upload/v1785587785/White_Logo_ifynbk.png" alt="Ceylanthro" width="180" style="display: block; margin: 0 auto;" />
            </td>
          </tr>
          <tr>
            <td style="padding: 50px 40px; text-align: center;">
              <h1 style="color: #d4af37; margin: 0 0 20px 0; font-size: 28px; font-weight: normal; letter-spacing: -0.5px;">Welcome to Ceylanthro!</h1>
              <p style="color: #4b5563; font-size: 16px; line-height: 1.6; margin: 0 0 30px 0; text-align: left;">Thank you for joining us. To complete your registration and start experiencing the finest Ceylon wellness products, please verify your email address by clicking the button below:</p>
              
              <a href="{{ .ConfirmationURL }}" style="display: inline-block; background-color: #2c3625; color: #ffffff; padding: 16px 40px; text-decoration: none; border-radius: 8px; font-weight: bold; text-transform: uppercase; font-size: 14px; letter-spacing: 1px; box-shadow: 0 4px 12px rgba(44,54,37,0.2);">Verify My Account</a>
              
              <p style="color: #9ca3af; font-size: 14px; line-height: 1.6; margin: 30px 0 0 0; text-align: left;">If you did not create an account, you can safely ignore this email.</p>
            </td>
          </tr>
          <tr>
            <td style="background-color: #faf9f6; padding: 40px 40px; text-align: center; border-top: 1px solid #eee;">
              <p style="margin: 0 0 12px 0; font-size: 16px; color: #2c3625; font-weight: bold; letter-spacing: 0.5px;">PURE CEYLON NATURE</p>
              <p style="margin: 0 0 24px 0; font-size: 14px; color: #6b7264; line-height: 1.5;">Experience the finest authentic wellness products,<br>sustainably sourced from Sri Lanka.</p>
              <div style="margin-bottom: 24px;">
                <a href="https://ceylanthro.com" style="display: inline-block; margin: 0 15px; color: #d4af37; text-decoration: none; font-size: 13px; font-weight: bold; text-transform: uppercase; letter-spacing: 1px;">Visit Store</a>
                <span style="color: #d1d5db;">|</span>
                <a href="mailto:orders@email.ceylanthro.com" style="display: inline-block; margin: 0 15px; color: #d4af37; text-decoration: none; font-size: 13px; font-weight: bold; text-transform: uppercase; letter-spacing: 1px;">Contact Support</a>
              </div>
              <p style="margin: 0; font-size: 12px; color: #9ca3af;">&copy; 2026 Ceylanthro. All rights reserved.<br>Colombo, Sri Lanka</p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`
  },
  {
    name: 'Reset Password',
    subject: 'Reset Your Ceylanthro Password',
    html: `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>
<body style="margin: 0; padding: 0; background-color: #f4f5f3; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; -webkit-font-smoothing: antialiased;">
  <table width="100%" border="0" cellspacing="0" cellpadding="0" style="background-color: #f4f5f3; padding: 40px 0;">
    <tr>
      <td align="center">
        <table width="600" border="0" cellspacing="0" cellpadding="0" style="background-color: #ffffff; border-radius: 16px; overflow: hidden; box-shadow: 0 10px 30px rgba(0,0,0,0.08); margin: 0 auto;">
          <tr>
            <td align="center" style="background-color: #2c3625; padding: 45px 20px; text-align: center; border-bottom: 4px solid #d4af37;">
              <img src="https://res.cloudinary.com/dfg8nrgvf/image/upload/v1785587785/White_Logo_ifynbk.png" alt="Ceylanthro" width="180" style="display: block; margin: 0 auto;" />
            </td>
          </tr>
          <tr>
            <td style="padding: 50px 40px; text-align: center;">
              <h1 style="color: #d4af37; margin: 0 0 20px 0; font-size: 28px; font-weight: normal; letter-spacing: -0.5px;">Reset Your Password</h1>
              <p style="color: #4b5563; font-size: 16px; line-height: 1.6; margin: 0 0 30px 0; text-align: left;">We received a request to reset your password. Click the button below to choose a new password for your account:</p>
              
              <a href="{{ .ConfirmationURL }}" style="display: inline-block; background-color: #2c3625; color: #ffffff; padding: 16px 40px; text-decoration: none; border-radius: 8px; font-weight: bold; text-transform: uppercase; font-size: 14px; letter-spacing: 1px; box-shadow: 0 4px 12px rgba(44,54,37,0.2);">Reset Password</a>
              
              <p style="color: #9ca3af; font-size: 14px; line-height: 1.6; margin: 30px 0 0 0; text-align: left;">If you didn't request a password reset, you can safely ignore this email. Your password will remain unchanged.</p>
            </td>
          </tr>
          <tr>
            <td style="background-color: #faf9f6; padding: 40px 40px; text-align: center; border-top: 1px solid #eee;">
              <p style="margin: 0 0 12px 0; font-size: 16px; color: #2c3625; font-weight: bold; letter-spacing: 0.5px;">PURE CEYLON NATURE</p>
              <p style="margin: 0 0 24px 0; font-size: 14px; color: #6b7264; line-height: 1.5;">Experience the finest authentic wellness products,<br>sustainably sourced from Sri Lanka.</p>
              <div style="margin-bottom: 24px;">
                <a href="https://ceylanthro.com" style="display: inline-block; margin: 0 15px; color: #d4af37; text-decoration: none; font-size: 13px; font-weight: bold; text-transform: uppercase; letter-spacing: 1px;">Visit Store</a>
                <span style="color: #d1d5db;">|</span>
                <a href="mailto:orders@email.ceylanthro.com" style="display: inline-block; margin: 0 15px; color: #d4af37; text-decoration: none; font-size: 13px; font-weight: bold; text-transform: uppercase; letter-spacing: 1px;">Contact Support</a>
              </div>
              <p style="margin: 0; font-size: 12px; color: #9ca3af;">&copy; 2026 Ceylanthro. All rights reserved.<br>Colombo, Sri Lanka</p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`
  }
];

const AdminEmails = () => {
  const [activeTab, setActiveTab] = useState('order_emails');
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [copied, setCopied] = useState(null);

  // Test Email States
  const [testEmail, setTestEmail] = useState('');
  const [isTesting, setIsTesting] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const [viewMode, setViewMode] = useState('code');

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    setLoading(true);
    const { data, error } = await supabase.from('email_templates').select('*').order('name');
    if (data) {
      setTemplates(data);
      if (data.length > 0 && !selectedTemplate) {
        setSelectedTemplate(data[0]);
      }
    }
    setLoading(false);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { error } = await supabase
        .from('email_templates')
        .update({
          subject: selectedTemplate.subject,
          html_content: selectedTemplate.html_content,
          updated_at: new Date().toISOString()
        })
        .eq('id', selectedTemplate.id);

      if (error) throw error;
      alert('Template saved successfully!');
      fetchTemplates();
    } catch (err) {
      alert('Error saving template: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleTestEmail = async (e) => {
    e.preventDefault();
    if (!testEmail) return alert("Please enter an email address for testing.");
    
    setIsTesting(true);
    setTestResult(null);

    try {
      const { data: { session } } = await supabase.auth.getSession();
      const { data, error } = await supabase.functions.invoke('send-email', {
        body: { test_email: testEmail, template_id: selectedTemplate.id },
        headers: { Authorization: `Bearer ${session?.access_token}` }
      });

      if (error) throw error;
      if (data?.error) throw new Error(data.error);

      setTestResult({ success: true, message: data.message || "Test email sent successfully!" });
    } catch (err) {
      setTestResult({ success: false, message: err.message });
    } finally {
      setIsTesting(false);
    }
  };

  const handleCopy = (text, id) => {
    navigator.clipboard.writeText(text);
    setCopied(id);
    setTimeout(() => setCopied(null), 2000);
  };

  if (loading && templates.length === 0) return <div className="p-8 text-center text-gray-500">Loading templates...</div>;

  return (
    <div className="space-y-6 pb-12">
      <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm mb-6">
        <div className="flex items-center gap-3 mb-2">
          <SafeIcon icon={FiMail} className="text-brand-gold w-6 h-6" />
          <h2 className="text-2xl font-serif text-gray-800">Email Templates</h2>
        </div>
        <p className="text-sm text-gray-500">Manage automated order notifications and Supabase authentication emails.</p>
      </div>

      <div className="flex gap-4 border-b border-gray-200 mb-6">
        <button onClick={() => setActiveTab('order_emails')} className={`pb-4 px-2 font-bold text-sm uppercase tracking-wider transition-colors ${activeTab === 'order_emails' ? 'border-b-2 border-brand-gold text-brand-darkSage' : 'text-gray-400 hover:text-gray-700'}`}>
          Order Notifications
        </button>
        <button onClick={() => setActiveTab('auth_emails')} className={`pb-4 px-2 font-bold text-sm uppercase tracking-wider transition-colors ${activeTab === 'auth_emails' ? 'border-b-2 border-brand-gold text-brand-darkSage' : 'text-gray-400 hover:text-gray-700'}`}>
          Supabase Auth Templates
        </button>
      </div>

      {activeTab === 'order_emails' ? (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm">
              <h3 className="font-bold text-gray-800 mb-4 uppercase tracking-wider text-xs">Select Template</h3>
              <div className="space-y-2 max-h-[400px] overflow-y-auto custom-scrollbar pr-2">
                {templates.map(t => (
                  <button
                    key={t.id}
                    onClick={() => setSelectedTemplate(t)}
                    className={`w-full text-left px-4 py-3 rounded-xl text-sm font-semibold transition-all ${
                      selectedTemplate?.id === t.id 
                      ? 'bg-brand-darkSage text-white shadow-md' 
                      : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
                    }`}
                  >
                    {t.name.replace(/_/g, ' ').toUpperCase()}
                  </button>
                ))}
              </div>
            </div>

            <div className="bg-brand-sand/30 p-6 rounded-2xl border border-brand-darkSage/10">
              <h3 className="font-bold text-brand-darkSage mb-4 uppercase tracking-wider text-xs flex items-center gap-2">
                <SafeIcon icon={FiSend} /> Send Live Test
              </h3>
              <form onSubmit={handleTestEmail} className="space-y-4">
                <div>
                  <label className="block text-xs font-bold text-gray-500 mb-2">Recipient Email</label>
                  <input 
                    type="email" 
                    required
                    value={testEmail}
                    onChange={(e) => setTestEmail(e.target.value)}
                    placeholder="test@example.com"
                    className="w-full border border-gray-300 rounded-lg px-4 py-2 text-sm outline-none focus:border-brand-gold"
                  />
                </div>
                <button 
                  type="submit" 
                  disabled={isTesting || !selectedTemplate}
                  className="w-full bg-brand-darkSage text-white py-2.5 rounded-xl text-xs font-bold uppercase tracking-widest hover:bg-brand-gold transition-colors disabled:opacity-50"
                >
                  {isTesting ? 'Sending...' : 'Send Test Email'}
                </button>
                
                {testResult && (
                  <div className={`p-3 rounded-lg text-xs font-bold ${testResult.success ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                    {testResult.message}
                  </div>
                )}
              </form>
            </div>
          </div>

          {selectedTemplate && (
            <div className="lg:col-span-2 bg-white rounded-2xl border border-gray-100 shadow-sm flex flex-col">
              <div className="p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50/50 rounded-t-2xl">
                <h3 className="font-bold text-gray-800 uppercase tracking-wider text-xs">Edit Template</h3>
                <div className="flex bg-white rounded-lg border border-gray-200 overflow-hidden">
                  <button 
                    onClick={() => setViewMode('code')}
                    className={`px-4 py-1.5 text-xs font-bold uppercase tracking-wider flex items-center gap-2 ${viewMode === 'code' ? 'bg-brand-darkSage text-white' : 'text-gray-500 hover:bg-gray-50'}`}
                  >
                    <SafeIcon icon={FiCode} /> Code
                  </button>
                  <button 
                    onClick={() => setViewMode('preview')}
                    className={`px-4 py-1.5 text-xs font-bold uppercase tracking-wider flex items-center gap-2 ${viewMode === 'preview' ? 'bg-brand-darkSage text-white' : 'text-gray-500 hover:bg-gray-50'}`}
                  >
                    <SafeIcon icon={FiEye} /> Preview
                  </button>
                </div>
              </div>
              
              <form onSubmit={handleSave} className="p-6 flex-1 flex flex-col space-y-4">
                <div>
                  <label className="block text-xs font-bold text-gray-500 uppercase tracking-widest mb-2">Email Subject</label>
                  <input 
                    type="text" 
                    required
                    value={selectedTemplate.subject}
                    onChange={(e) => setSelectedTemplate({...selectedTemplate, subject: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm outline-none focus:border-brand-gold font-semibold"
                  />
                </div>

                <div className="flex-1 flex flex-col">
                  <label className="block text-xs font-bold text-gray-500 uppercase tracking-widest mb-2 flex justify-between">
                    <span>HTML Content</span>
                    <span className="text-[10px] text-brand-gold lowercase font-mono hidden sm:inline">Available variables: {'{{customer_name}}, {{order_id}}, {{items_html}}, {{total_amount}}, {{payment_status}}'}</span>
                  </label>
                  
                  {viewMode === 'code' ? (
                    <textarea 
                      required
                      value={selectedTemplate.html_content}
                      onChange={(e) => setSelectedTemplate({...selectedTemplate, html_content: e.target.value})}
                      className="w-full flex-1 min-h-[500px] border border-gray-300 rounded-lg p-4 text-xs font-mono bg-gray-50 outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold"
                    />
                  ) : (
                    <div 
                      className="w-full flex-1 min-h-[500px] border border-gray-300 rounded-lg p-4 bg-white overflow-auto"
                      dangerouslySetInnerHTML={{ 
                        __html: selectedTemplate.html_content
                          .replace(/{{customer_name}}/g, "John Doe")
                          .replace(/{{order_id}}/g, "ORD-SAMPLE")
                          .replace(/{{items_html}}/g, '<div style="display: flex; justify-content: space-between; border-bottom: 1px solid #eee; padding: 10px 0;"><div><strong>Sample Premium Item</strong><br><span style="color: #7a8775; font-size: 12px;">Qty: 1</span></div><div>Rs. 1500.00</div></div>')
                          .replace(/{{total_amount}}/g, "1500.00")
                          .replace(/{{payment_status}}/g, "PAID")
                      }}
                    />
                  )}
                </div>

                <div className="pt-4 border-t border-gray-100 flex justify-end">
                  <button 
                    type="submit" 
                    disabled={saving}
                    className="flex items-center gap-2 bg-brand-darkSage text-white px-8 py-3 rounded-xl font-bold tracking-widest uppercase text-xs hover:bg-brand-gold transition-colors disabled:opacity-50"
                  >
                    <SafeIcon icon={FiSave} /> {saving ? 'Saving...' : 'Save Template'}
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      ) : (
        <div className="space-y-6">
          <div className="bg-blue-50 text-blue-800 p-4 rounded-xl text-sm border border-blue-100 mb-6">
            <strong>Instructions:</strong> Copy the HTML code below and paste it into your Supabase Dashboard under <strong>Authentication &gt; Email Templates</strong>.
          </div>
          {AUTH_TEMPLATES.map((tpl, i) => (
            <div key={i} className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
              <div className="p-6 border-b border-gray-100 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 bg-gray-50/50">
                <div>
                  <h3 className="font-bold text-gray-800 uppercase tracking-wider text-xs">{tpl.name}</h3>
                  <p className="text-xs text-gray-500 mt-1">Subject: {tpl.subject}</p>
                </div>
                <button 
                  onClick={() => handleCopy(tpl.html, i)}
                  className="flex items-center gap-2 bg-brand-darkSage text-white px-4 py-2.5 rounded-xl text-xs font-bold uppercase tracking-widest hover:bg-brand-gold transition-colors w-full sm:w-auto justify-center"
                >
                  <SafeIcon icon={copied === i ? FiCheck : FiCopy} />
                  {copied === i ? 'Copied!' : 'Copy HTML'}
                </button>
              </div>
              <div className="p-6 bg-[#1e1e1e] overflow-auto max-h-[400px]">
                <pre className="text-green-400 text-xs font-mono whitespace-pre-wrap">
                  {tpl.html}
                </pre>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminEmails;